"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
var _components = require("../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ModalFooter(_ref) {
  var _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    message = _ref.message,
    actionDisabled = _ref.actionDisabled,
    actionText = _ref.actionText,
    onAction = _ref.onAction,
    _ref$cancelText = _ref.cancelText,
    cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
    onCancel = _ref.onCancel;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-schedule-modal-footer flex flex-col items-center px-[24px]"
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loading
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pb-[16px]"
  }, message), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col items-center"
  }, /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    className: "w-[344px]",
    size: "large",
    disabled: actionDisabled,
    onClick: onAction
  }, actionText), /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    className: "mt-[24px]",
    size: "large",
    onClick: onCancel
  }, cancelText))));
}
var _default = ModalFooter;
exports.default = _default;